import { appSlice } from '../slices/app.slice';

export const { setChainId, setNodeId, setNodeVersion, setReferralCode, setNftId, setReceivedAddress } =
  appSlice.actions;
